<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="sec-9"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Contents"><h1 class="chapter1" id="pz9-1"><b>Contents</b> </h1>
<p class="cct"><span href="#/chapter01b#ab_01b" id="ba_01b" title="Link target outside of Sample"><em>Ebook Instructions</em> </span> </p>
<p class="cct" id="pz9-2"><a href="#/chapter02#ab_02" id="ba_02"><em>Introduction</em> </a> </p>
<p class="cct1" id="pz9-3"><span href="#/chapter04#ab_04" id="ba_04" title="Link target outside of Sample">Step 1: Make the End the Beginning</span> </p>
<p class="cct2" id="A-C"><em>The questions we ask at the end of life are the ones we should begin with.</em> </p>
<p class="cct1" id="pz9-6"><span href="#/chapter05#ab_05" id="ba_05" title="Link target outside of Sample">Step 2: Recognize Everything Is God’s</span> </p>
<p class="cct2" id="AQ7"><em>Generosity and legacy happen only when we return everything to the rightful owner.</em> </p>
<p class="cct1" id="pz9-7"><span href="#/chapter07#ab_07" id="ba_07" title="Link target outside of Sample">Step 3: Put People Before Profit</span> </p>
<p class="cct2" id="Ay"><em>Choose the eternal in the everyday mundane.</em> </p>
<p class="cct1" id="pz9-8"><span href="#/chapter08#ab_08" id="ba_08" title="Link target outside of Sample">Step 4: Consider All the Blessings You’ve Been Given</span> </p>
<p class="cct2" id="AKp"><em>The greatest blessings are the ones that can never be lost.</em> </p>
<p class="cct1" id="pz9-9"><span href="#/chapter09#ab_09" id="ba_09" title="Link target outside of Sample">Step 5: Develop a Vision for Generosity</span> </p>
<p class="cct2" id="ADG"><em>Every journey requires a destination.</em> </p>
<p class="cct1" id="pz10-1"><span href="#/chapter10#ab_10" id="ba_10" title="Link target outside of Sample">Step 6: Create a Plan for Generosity</span> </p>
<p class="cct2" id="AKk"><em>Those who plan to give, do.</em> </p>
<p class="cct1" id="pz10-2"><span href="#/chapter11#ab_11" id="ba_11" title="Link target outside of Sample">Step 7: Talk About Money with Your Children</span> </p>
<p class="cct2" id="ALg"><em>What you know, you can change. What you don’t know controls you.</em> </p>
<p class="cct1" id="pz10-3"><span href="#/chapter12#ab_12" id="ba_12" title="Link target outside of Sample">Step 8: Give Even When It Seems Impossible</span> </p>
<p class="cct2" id="Azl"><em>You won’t know whether you can out-give God until you try.</em> </p>
<p class="cct1" id="pz10-4"><span href="#/chapter13#ab_13" id="ba_13" title="Link target outside of Sample">Step 9: Create a Family Legacy Plan</span> </p>
<p class="cct2" id="AIp"><em>Passing on wealth means passing on all forms of wealth.</em> </p>
<p class="cct1" id="pz10-5"><span href="#/chapter14#ab_14" id="ba_14" title="Link target outside of Sample">Step 10: Stockpile Treasure in Heaven</span> </p>
<p class="cct3" id="AqN"><em>Legacy is not just what we leave behind, but what we send ahead.</em> </p>
<p class="cct" id="pz10-6"><span href="#/chapter15#ab_15" id="ba_15" title="Link target outside of Sample"><em>Notes</em> </span> </p>
<p class="cct" id="Ard"><span href="#/chapter16#ab_16" id="ba_16" title="Link target outside of Sample"><em>About the Author</em> </span> </p>
<p class="cct" id="Ai0"><span href="#/chapter17#ab_17" id="ba_17" title="Link target outside of Sample"><em>My Family Legacy Plan</em> </span> </p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-toc.vue?f07e28c0